import React, { useEffect, useState } from "react";
import dataService from "../networks/api/service/dataService";
import { Select, Card, Typography, Divider, Descriptions, Spin } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

function BoothDetails() {
  const [boothList, setBoothList] = useState([]);
  const [selectedBooth, setSelectedBooth] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch booth details
  const getBoothDetails = async () => {
    try {
      const response = await dataService.getBoothBasedAdmin();
      setBoothList(response.data);
      setSelectedBooth(response.data[0]);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBoothDetails();
  }, []);

  // Handle booth selection
  const handleBoothSelect = (boothId) => {
    const booth = boothList.find((b) => b._id === boothId);
    setSelectedBooth(booth);
  };

  return (
    <div style={{ padding: "30px 20px", backgroundColor: "#f7f7f7" }}>
      {/* Booth Select Dropdown */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "20px",
        }}
      >
        <Select
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) => {
            const children = option?.children;
            return String(children).toLowerCase().includes(input.toLowerCase());
          }}
          placeholder="Select a Booth Number"
          style={{
            width: 300,
            // boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            // borderRadius: "4px",
            // padding: "5px 10px",
            border: "1px solid grey",
            borderRadius: 5,
          }}
          value={selectedBooth?._id}
          onChange={handleBoothSelect}
          loading={loading}
        >
          {boothList.map((booth) => (
            <Select.Option key={booth._id} value={booth._id}>
              {booth.boothNumber} - {booth.boothName}
            </Select.Option>
          ))}
        </Select>
      </div>

      {/* Display booth details or loading spinner */}
      {loading ? (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <Spin size="large" />
        </div>
      ) : (
        selectedBooth && (
          <Card
            style={{
              marginTop: 20,
              borderRadius: "8px",
              boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.1)",
            }}
            title={
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: "1.4em",
                  fontWeight: "500",
                  color: "#595959",
                }}
              >
                <InfoCircleOutlined
                  style={{ marginRight: "10px", color: "#1890ff" }}
                />
                Booth Information
              </span>
            }
            bordered={true}
          >
            <Divider />

            {/* Descriptions displaying Booth info */}
            <Descriptions bordered column={1} style={{ fontSize: "1em" }}>
              <Descriptions.Item label="Booth Name">
                <Text strong>{selectedBooth.boothName}</Text>
              </Descriptions.Item>
              <Descriptions.Item label="Booth Number">
                <Text>{selectedBooth.boothNumber}</Text>
              </Descriptions.Item>
              <Descriptions.Item label="Total Population">
                <Text>{selectedBooth.totalPopulation}</Text>
              </Descriptions.Item>
              <Descriptions.Item label="Total Voters">
                <Text>{selectedBooth.totalVoters}</Text>
              </Descriptions.Item>
              <Descriptions.Item label="Total Male Voters">
                <Text>{selectedBooth.totalMaleVoters}</Text>
              </Descriptions.Item>
              <Descriptions.Item label="Total Female Voters">
                <Text>{selectedBooth.totalFemaleVoters}</Text>
              </Descriptions.Item>
            </Descriptions>
          </Card>
        )
      )}
    </div>
  );
}

export default BoothDetails;
